export default __webpack_public_path__ + "static/media/firebrigade.abb54707.jpg";